module.exports = __webpack_public_path__ + "img/eraser.be5030ca.webp";